import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import AssignmentDetailCard from '../AssignmentDetailCard/AssignmentDetailCard';

const styles = (theme) => ({});

class ActiveAssignmentDetailView extends Component {
    render() {
        const { assignment, assignmentTeam } = this.props;

        return !assignment ? (
            <p>Error, Assignment not found</p>
        ) : (
            <AssignmentDetailCard
                assignment={assignment}
                assignmentTeam={assignmentTeam}
                type="active"
            />
        );
    }
}

export default withStyles(styles)(ActiveAssignmentDetailView);
